import nodeClient from "./node-client";

export const saveHsn = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/hsn/master/save`,
    payload
  );
  return response?.data?.result;
};

export const getHsn = async () => {
  const response = await nodeClient.get(`/service/private/v0/hsn/master/find/all`);
  return response?.data?.result;
};

export const searchHsn = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/hsn/master/search?${encodeURI(query)}`
  );
  return response?.data?.result;
}